import React, { useContext, useEffect } from "react"
import { AuthContext } from "../../contexts/Authentication/AuthStateProvider"
import { usePageTitle } from "../../hooks/pageHead"
import useStyle from '../../hooks/useStyle'
import GeoLocation from "../Common/GeoLocation"
import PreLoadSpinner from "../PreLoadSpinner"
import useAuth from './useAuth'

let geoData = {}
const LoginUID = (props) => {
  useStyle('/css/login.css', true) 
  usePageTitle('Login')

  let params = props.match.params

  const { state: authState, dispatch } = useContext(AuthContext)
  const { user, setUser, handleFormSubmit, routeUser } = useAuth(props.history, dispatch, geoData)

  useEffect(()=>{
    if(params.uid){
      /*
        setUser({
          'registration_mode': 'uid',
          'uid': params.uid
        })
        setting uid like this not working
      */
      user.registration_mode = 'uid'
      user.uid = params.uid
      setUser({...user})
      handleFormSubmit()
    }else{
      props.history.push('/signin')
    }
  }, [])

  useEffect(() => {
    if(authState.isAuthenticated){
      routeUser(authState.user)
    }
  }, [authState.isAuthenticated])


  return (
    <div id="ct">
      <PreLoadSpinner/>
      <GeoLocation geoData={geoData} getAddress="true"/>
    </div>
  )

}

export default LoginUID;